import React, { useState } from 'react';
import { styled, alpha } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch } from 'react-redux';
import { InputBase } from '../mui';
import { setSearchTerm, setWizardMode } from '../../reducers/globalSlice';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  border: `1px solid ${theme.palette.primary.main}`,
  borderColor: theme.palette.primary.main,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    fontSize: '0.8em',
    [theme.breakpoints.up('sm')]: {
      width: '13ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

function CarSearch() {
  const [term, setTerm] = useState('');
  const dispatch = useDispatch();

  const handleChange = (event) => {
    const str = event.target.value;
    setTerm(str);
    dispatch(setWizardMode(false));
    dispatch(setSearchTerm(str));
  };

  return (
    <Search>
      <SearchIconWrapper>
        <SearchIcon color="primary" />
      </SearchIconWrapper>
      <StyledInputBase
        value={term}
        onChange={handleChange}
        placeholder="Search All Cars"
        inputProps={{ 'aria-label': 'search' }}
      />
    </Search>
  );
}

export default CarSearch;
